module.exports = vendors_ru_646766c48e62e380c6c4;